module.exports = __webpack_public_path__ + "static/media/severino_martin_soash.3f324e34.jpg";